<div class="container-fluid customers-root">
  <div class="table-root">
    <div class="table-action-wrapper">
      <div class="table-action-inner d-flex align-items-center">
      <div class="d-flex">
        <div id="wo_scc_search" class="search-input">
          <img src="../../assets/icons/search.svg" alt="Search icon" (click)="search()" />
          <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="searchText"
            (keydown.enter)="search()" (ngModelChange)="this.searchTextUpdate.next($event)" />
        </div>
        <div id="wo_scc_search-by" class="search-type-picker">
          <div [title]="selectedSearchTypeDisplay | translate" class="dropdown" #stTrigger
            (click)="openDropdown('st', stTrigger)" click-stop-propagation>
            <span>{{ "COMMON.BY" | translate }}:</span>
            <span>{{ selectedSearchTypeDisplay | translate }}</span>
            <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
          </div>
          <div class="dropdown-opened" *ngIf="showSelectSearchType" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left">
            <div [id]="'wo_scc_search-by-' + (i + 1)" (click)="selectSearchType(searchType)"
              *ngFor="let searchType of searchByOptions; let i = index">
              <div>{{ searchType.translation | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div>
          <div class="d-flex">
            <div id="wo_scc_date-type" class="datetype-picker">
              <div [title]="selectedDateTypeDisplay | translate" class="dropdown" #dtTrigger
                (click)="openDropdown('dt', dtTrigger)" click-stop-propagation>
                <span>{{ "COMMON.DATE_TYPE.TITLE" | translate }}:</span>
                <span>{{ selectedDateTypeDisplay | translate}}</span>
                <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
              </div>
              <div class="dropdown-opened" *ngIf="showSelectDateType" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left">
                <div [id]="'wo_scc_date-type-' + (i + 1)" (click)="
                    selectDateType(dateType);
                    datesValid() == true && (dateTo || dateFrom) && search()
                  " *ngFor="let dateType of dateTypes; let i = index">
                  <div>{{ dateType.translation | translate }}</div>
                </div>
              </div>
            </div>
            <div id="wo_scc_date-from" class="datepicker-container" style="width: 23rem;">
              <label> {{ "COMMON.FROM" | translate }}: </label>
              <input type="date" id="dateFrom" name="dateFrom" [ngClass]="
                  !datesValid()
                    ? 'btn datepicker-icon-error'
                    : 'btn datepicker-icon'
                " [(ngModel)]="dateFrom" (change)="datesValid() == true && search()" />
            </div>

            <div id="wo_scc_date-to" class="datepicker-container" style="width: 20rem;">
              <label class="right-label">
                {{ "COMMON.TO" | translate }}:
              </label>
              <input type="date" id="dateTo" name="dateTo" [ngClass]="
                  !datesValid()
                    ? 'btn datepicker-icon-error'
                    : 'btn datepicker-icon'
                " [(ngModel)]="dateTo" (change)="datesValid() == true && search()" />
            </div>
          </div>
        </div>
        <div id="wo_scc_sort-by" class="sort-by-root" style="width: 16.5rem;" #sbTrigger (click)="openDropdown('sb', sbTrigger)"
          click-stop-propagation>
          <div class="dropdown" [title]="sortByLabelValue.label | translate">
            <span>{{ "COMMON.SORT_BY.TITLE" | translate }}:</span>
            <span style="white-space: wrap;">{{ sortByLabelValue.label | translate
              }}<img *ngIf="sortByLabelValue.arrow !== 'no'" [ngClass]="{ 'arrow-up': sortByLabelValue.arrow === 'up' }"
                src="../../../assets/icons/arrow.svg" /></span>
            <span><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
          </div>
          <div class="dropdown-opened v-2"
            *ngIf="showSortBy && filterByValue != filterByOptions.ONBOARDED" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left">
            <div id="wo_scc_sort-by-newest" (click)="sortBy(sortByOptions.NEWEST)">
              <div>{{ "COMMON.SORT_BY.NEWEST" | translate }}</div>
            </div>
            <div id="wo_scc_sort-by-slrn-asc" (click)="sortBy(sortByOptions.SLRN_ASC)">
              <div>{{ "COMMON.SLRN" | translate }}</div>
              <img class="arrow-up" src="../../../assets/icons/arrow.svg" alt="Arrow icon" />
            </div>
            <div id="wo_scc_sort-by-slrn-desc" (click)="sortBy(sortByOptions.SLRN_DESC)">
              <div>{{ "COMMON.SLRN" | translate }}</div>
              <img src="../../../assets/icons/arrow.svg" alt="Arrow icon" />
            </div>
            <div id="wo_scc_sort-by-acc-no-asc" (click)="sortBy(sortByOptions.ACCNO_ASC)">
              <div>{{ "COMMON.SORT_BY.ACCOUNT_NO" | translate }}</div>
              <img class="arrow-up" src="../../../assets/icons/arrow.svg" alt="Arrow icon" />
            </div>
            <div id="wo_scc_sort-by-acc-no-desc" (click)="sortBy(sortByOptions.ACCNO_DESC)">
              <div>{{ "COMMON.SORT_BY.ACCOUNT_NO" | translate }}</div>
              <img src="../../../assets/icons/arrow.svg" alt="Arrow icon" />
            </div>
          </div>
          <div class="dropdown-opened" *ngIf="showSortBy && filterByValue == filterByOptions.ONBOARDED" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left">
            <div id="wo_scc_sort-by-newest-v2" (click)="sortBy(sortByOptions.NEWEST)">
              <div>{{ "COMMON.SORT_BY.NEWEST" | translate }}</div>
            </div>
            <div id="wo_scc_sort-by-oldest-v2" (click)="sortBy(sortByOptions.OLDEST)">
              <div>{{ "COMMON.SORT_BY.OLDEST" | translate }}</div>
            </div>
          </div>
        </div>
        <button class="btn btn-icon" *ngIf="permissionsService.isServiceRequestAuthDownloadAllowed" (click)="download()">
          <span>{{'COMMON.DOWNLOAD' | translate}}</span>
        </button>
        <div class="upload-dropdown-wrapper" *ngIf="permissionsService.isServiceRequestAuthBulkUploadAllowed">
          <button class="btn btn-primary btn-upload-chevron" #uploadTrigger (click)="openDropdown('ul', uploadTrigger)" click-stop-propagation>
            <img src="../../assets/icons/chevron-down.svg" alt="Chevron down" />
          </button>
          <button class="btn btn-primary btn-upload-text" [title]="'COMMON.REQUEST_AUTH' | translate" [routerLink]="'/upload/34/' + utilityId" click-stop-propagation>
            <img src="../../assets/icons/upload-arrow.svg" alt="Upload icon" />
            <span class="upload-text">{{ "COMMON.REQUEST_AUTH" | translate }}</span>
          </button>
          <div *ngIf="showUpload" class="xlsx-upload" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left" [routerLink]="'/upload/34/' + utilityId">
            <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload icon" /></div>
            <div>{{ "COMMON.UPLOAD_XLSX" | translate }}</div>
          </div>
        </div>
        <div *ngIf="
            filterByValue === filterByOptions.NEW &&
            withAccNoSelected === 2 &&
            isRegularizationUploadVisible
          ">
          <button [routerLink]="'/upload/11/' + utilityId" class="btn btn-primary" click-stop-propagation>
            <div>
              <img style="margin-right: 0rem !important" src="../../assets/icons/upload-arrow.svg" />
            </div>
          </button>
        </div>
      </div>
      </div>
    </div>
    <div class="filter">
      <div class="filter-list">
        {{ "COMMON.FILTER" | translate }}
        <app-multi-select-dropdown id="wo_scc_region_filter" class="multiselect" [clicked]="clicked"
          [items]="hasCimDataIntegration ? geographicalRegions : regions"
          [label]="'COMMON.BU.PLURAL'" [showMore]="false" [requireApply]="true"
          (shareIndividualCheckedList)="hasCimDataIntegration ? selectGeographicalRegion($event) : selectRegion($event)">
        </app-multi-select-dropdown>
        <app-multi-select-dropdown id="wo_scc_area_filter" class="multiselect" [clicked]="clicked"
          [items]="hasCimDataIntegration ? subGeographicalRegions : areas"
          [label]="'COMMON.UT.PLURAL'" [showMore]="false" [requireApply]="true"
          (shareIndividualCheckedList)="selectArea($event)">
        </app-multi-select-dropdown>

        <app-multi-select-dropdown id="wo_scc_user_filter" class="multiselect" [searchFilterActive]="true"
          (filterValue)="applySearchFilter($event)" [clicked]="clicked" [items]="filteredUsers"
          [label]="'COMMON.USER.PLURAL'" [showMore]="false" [requireApply]="true"
          (shareIndividualCheckedList)="selectUsers($event)" (applyFilterEmitter)="applyUserFilter()">
        </app-multi-select-dropdown>

        <select id="wo_scc_new-conn-status_filter" name="status-select" (change)="selectKycStatus($event)"
          class="form-select">
          <option value="" [selected]="!kycStatus" disabled>
            {{ "NEW_SERVICE.NEW_CONN_STATUS" | translate }}
          </option>
          <option [id]="'wo_scc_new-conn-status_filter-' + (i + 1)" [selected]="kycStatus == s.value"
            *ngFor="let s of kycStatusOptions; let i = index" value="{{ s.value }}">
            {{ s.translation | translate }}
          </option>
        </select>

        <select id="wo_scc_tag_filter" name="tag-select" (change)="selectKycTag($event)" class="form-select">
          <option value="" [selected]="kycTag === undefined" disabled>
            {{ "COMMON.TAG.TITLE" | translate }}
          </option>
          <option [id]="'wo_scc_tag_filter-' + (i + 1)" [selected]="kycTag == t.value"
            *ngFor="let t of kycTagOptions; let i = index" value="{{ t.value }}">
            {{ t.translation | translate }}
          </option>
        </select>
        <select (change)="selectSltStatus($event)" class="form-select" [disabled]="isSltDropdownDisabled">
          <option value="" [selected]="!sltStatus" disabled>Service Type</option>
          <option [id]="'new_service_service-type-' + (i + 1)" [selected]="sltStatus == s.id"
            *ngFor="let s of sltOptions; let i = index" value="{{ s.id }}">
            {{ s.displayValue | translate }}
          </option>
        </select>
        <select (change)="selectSubserviceType($event)" class="form-select">
          <option value="" [selected]="selectedSubserviceType === undefined" disabled>Service Request Type</option>
          <option [id]="'new_service_service-type-' + (i + 1)" [selected]="selectedSubserviceType == s.value"
            *ngFor="let s of subServiceTypeOptions; let i = index" value="{{ s.value }}">
            {{ s.displayValue | translate }}
          </option>
        </select>
 
        <app-multi-select-dropdown id="wo_scc_project-designation_filter" class="multiselect" [clicked]="clicked"
          [items]="projectDesignations" [label]="'NEW_SERVICE.PROJECT_DESIGNATIONS'" [showMore]="false" [requireApply]="true"
          (shareIndividualCheckedList)="selectProjectDesignation($event)">
        </app-multi-select-dropdown>
           <app-multi-select-dropdown id="new_service_project_status_filter" class="multiselect"
          [clicked]="clicked" [items]="projectTypeOptions" [label]="'NEW_SERVICE.PROJECT_STATUS'" [showMore]="false"
          [requireApply]="true" (shareIndividualCheckedList)="selectProjectType()">
        </app-multi-select-dropdown>
      </div>

      <div *ngIf="selectedFilters.length > 0">
        <app-filter-checklist [filters]="selectedFilters" [useApply]="true" (resetFilterEmitter)="resetFilter()"
          (removeFilterEmitter)="removeFilter($event)" (applyFilterEmitter)="applyFilter($event)">
        </app-filter-checklist>
      </div>
    </div>

    <div class="table table-overflow">
      <div *ngIf="customers">
        <table class="table">
          <thead class="table-light">
            <tr>
              <th id="wo_scc_table_header_checkbox">
                <input type="checkbox" class="form-check-input" [ngModel]="allCheckboxesChecked"
                  (click)="checkAllCheckboxes()" />
              </th>
              <th id="wo_scc_table_header_app-num">{{ "COMMON.TABLE_HEADERS.APP_NUM" | translate }}</th>
              <th id="wo_scc_table_header_building-owner">{{ "COMMON.TABLE_HEADERS.BUILDING_OWNER" | translate }}</th>
              <th id="wo_scc_table_header_region">{{ "COMMON.BU.SINGLE" | translate }}</th>
              <th id="wo_scc_table_header_district">{{ "COMMON.UT.SINGLE" | translate }}</th>
              <th id="wo_scc_table_header_feeder-band">{{ "NEW_SERVICE.FEEDER_BAND" | translate }}</th>
              <th id="wo_scc_table_header_feeder-name">{{ "NEW_SERVICE.FEEDER_NAME" | translate }}</th>
              <th id="wo_scc_table_header_dt-name">{{ "NEW_SERVICE.DT_NAME" | translate }}</th>
              <th id="wo_scc_table_header_address">{{ "COMMON.ADDRESS" | translate }}</th>
              <th id="wo_scc_table_header_request">{{ 'NEW_SERVICE.REQUEST_COUNT' | translate}}</th>
              <th id="new_service_table_header_sltStatus">{{'NEW_SERVICE.SERVICE_TYPE' | translate}}</th>
              <th id="new_service_table_header_subserviceType">{{'NEW_SERVICE.SERVICE_REQUEST_TYPE' | translate}}</th>
              <th id="new_service_table_header_projectStatus">{{'NEW_SERVICE.PROJECT_STATUS' | translate}}</th>
              <th id="wo_scc_table__header_projectDesignation"> {{'NEW_SERVICE.PROJECT_DESIGNATION' | translate}}</th>
              <th id="wo_scc_table_header_tag">{{ "COMMON.TAG.TITLE" | translate }}</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr [id]="'wo_scc_table_row-' + (i + 1)" *ngFor="let accountKyc of accountKycs; let i = index"
              (click)="selectServiceConnection(accountKyc.id)">
              <td [id]="'wo_scc_table-checkbox-' + (i + 1)"><input type="checkbox" class="form-check-input" /></td>
              <td [id]="'wo_scc_table_app-num-' + (i + 1)">
                {{ accountKyc.applicationNumber | hasValue }}
              </td>
              <td [id]="'wo_scc_table_building-owner-' + (i + 1)">
                {{ accountKyc.buildingOwner | hasValue }}
              </td>
              <td [id]="'wo_scc_table_region-' + (i + 1)">
                {{ (hasCimDataIntegration ? accountKyc.geographicalRegion : accountKyc.region) | hasValue }}
              </td>
              <td [id]="'wo_scc_table_area-' + (i + 1)">
                {{ (hasCimDataIntegration ? accountKyc.subGeographicalRegion : accountKyc.area) | hasValue }}
              </td>
              <td [id]="'wo_scc_table_feeder-band-' + (i + 1)">
                {{  accountKyc.feederBand | hasValue }}
              </td>
              <td [id]="'wo_scc_table_feeder-name-' + (i + 1)">
                {{  accountKyc.feederName | hasValue }}
              </td>
              <td [id]="'wo_scc_table_dt-name-' + (i + 1)">
                {{  accountKyc.dtName | hasValue }}
              </td>
              <td [id]="'wo_scc_table_address-' + (i + 1)">
                {{ accountKyc.address | hasValue }}
              </td>
              <td [id]="'wo_scc_table-request-' + (i + 1)">
                {{ accountKyc.requestCount | hasValue }}
              </td>
              <td [id]="'wo_scc_table-sltStatus-' + (i + 1)">{{ accountKyc.sltStatus | hasValue }}</td>
              <td [id]="'wo_scc_table_-subserviceType-' + (i + 1)">{{ accountKyc.subServiceType | hasValue }}</td>
              <td [id]="'wo_scc_table-projectStatus-' + (i + 1)">{{ accountKyc.projectStatus | hasValue }}</td>
              <td [id]="'wo_scc_table-project_designation-' + (i + 1)">
                  {{ accountKyc.projectDesignation | hasValue }}
              </td>
              <td [id]="'wo_scc_table_tag-' + (i + 1)">
                <div class="building-status" [ngClass]="{
                    'orange-status v-2': accountKyc.tag == 'New Customer',
                    'green-status v-2': accountKyc.tag == 'Existing'
                  }">
                  {{ accountKyc.tag | hasValue }}
                </div>
              </td>
              <td class="td-svg">
                <!-- data-bs-toggle="modal" data-bs-target="#history" -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="22" height="22">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z" />
                </svg>
              </td>
              <td class="more-icon">
                <img src="../../assets/icons/more-icon.svg" alt="More icon" class="more-icon" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div>
      <app-paging *ngIf="count > 0" [pageSize]="pageSize" [useDirect]="true" [count]="count" [currentPage]="currentPage"
        (pageChange)="pageChange($event)"></app-paging>
    </div>
  </div>
</div>
<button class="btn btn-primary" #openUpdateDescriptionModal data-bs-toggle="modal" data-bs-target="#history"
  hidden></button>

<app-history [isViewHistory]="isViewHistory" [historyItems]="historyItems"></app-history>
